import { render, staticRenderFns } from "./extraInfo.vue?vue&type=template&id=fd3caf36"
import script from "./extraInfo.vue?vue&type=script&lang=js"
export * from "./extraInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports